var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4975",
    "data-name": "Group 4975",
    transform: "translate(11788.482 14947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7956",
    "data-name": "Path 7956",
    d: "M2,0H23a2,2,0,0,1,2,2V23a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "translate(-11788.482 -14947)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8059",
    "data-name": "Path 8059",
    d: "M8.546,16.235,5.628,12.767a1,1,0,0,0-1.424,0,1.016,1.016,0,0,0,0,1.437l3.62,4.176a1.007,1.007,0,0,0,1.434,0l8.35-10.962a1.016,1.016,0,0,0,0-1.437,1,1,0,0,0-1.424,0Z",
    transform: "translate(-11786.388 -14946.681)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.dcc7bc5e82643c1472c45bc148fcc505.svg";
export { ForwardRef as ReactComponent };